export enum GlobalMeasureCheckAction{
	VALIDATE = 'VALIDATE',
	PUBLISH_REOPEN = 'PUBLISH_REOPEN',
	DELETE = 'DELETE',
	SNAPSHOT = 'SNAPSHOT',
	OBSOLETE = 'OBSOLETE',
	EDIT_CHAPTER_CUSTOM = 'EDIT_CHAPTER_CUSTOM',
}
